import { render, staticRenderFns } from "./ProductsCategory.vue?vue&type=template&id=1da37a24&scoped=true"
import script from "./ProductsCategory.vue?vue&type=script&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductsCategory.vue?vue&type=style&index=0&id=1da37a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da37a24",
  null
  
)

export default component.exports